import { RouterProvider } from "react-router-dom";
import { Providers } from "./providers";
import { router } from "./router";
import { ErrorBoundary } from "./ErrorBoundary";

/**
 * La red va POR FUERA de los proveedores, no por dentro.
 *
 * Si envolviera solo al router, un fallo al arrancar el cliente de queries,
 * el i18n o la restauración de sesión —los tres corren en `Providers`— se
 * escaparía sin atrapar y dejaría la pantalla en blanco de siempre. Aquí
 * arriba no se escapa nada de lo que pinta React.
 */
export function App() {
  return (
    <ErrorBoundary>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </ErrorBoundary>
  );
}
